import { useState } from "react";
import useI18n from "@/hooks/useI18n";
import Alert from "@/atomic/atoms/Alert";
import ScrapersConsultationCard from "@/atomic/molecules/ScrapersConsultationCard";
import TagIncentiveCard from "@/atomic/molecules/TagIncentiveCard";
import PartnersConcessionairesDrawer from "@/atomic/molecules/PartnersConcessionairesDrawer";
import { ScrapersConsultation } from "@/domain/scrapers/consultation";

interface EmptyConsultationResultProps {
  consultation: ScrapersConsultation;
  onSearchAnotherPlate: () => void;
}

export default function EmptyConsultationResult({
  consultation,
  onSearchAnotherPlate,
}: EmptyConsultationResultProps) {
  const { t } = useI18n();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const hasScraperPassages = consultation.hasAnyPassage;
  const showTagIncentive =
    consultation.isComplete &&
    !hasScraperPassages &&
    !consultation.hasConsultationError;

  return (
    <div className="flex flex-col gap-6 pt-6 pb-8">
      <div className="flex flex-col items-center text-center">
        <img
          src="/svg/icon-freeflow.svg"
          alt=""
          width={40}
          height={40}
          className="w-10 h-10"
        />
        <h2 className="mt-4 text-[22px] font-bold font-primary text-tertiary tracking-[-0.1px] leading-[1.1]">
          {t("pages:home:consultationDone")}
        </h2>
        <p className="mt-2 text-base font-primary text-text-secondary leading-[1.4]">
          {t("pages:home:noDebtsRegisteredPartners")}
        </p>
        <button
          type="button"
          onClick={() => setIsDrawerOpen(true)}
          className="mt-4 text-sm font-light font-primary text-primary underline"
        >
          {t("pages:home:consultPartnersList")}
        </button>
      </div>

      <div className="w-full h-px bg-border" />

      {hasScraperPassages && (
        <p className="text-base font-medium font-secondary text-text text-center tracking-[-0.4px] leading-[20.8px]">
          {t("pages:home:passagesInOtherConcessionaires")}
        </p>
      )}

      <Alert variant="highlight" showIcon={false}>
        {t("pages:home:passagesPayOnConcessionaireSite")}
      </Alert>

      <ScrapersConsultationCard consultation={consultation} />
      {showTagIncentive && <TagIncentiveCard />}

      <button
        type="button"
        onClick={onSearchAnotherPlate}
        className={
          hasScraperPassages
            ? "w-full h-[60px] rounded-xl border border-text flex items-center justify-center text-base font-bold font-primary text-text"
            : "text-sm font-primary text-text underline text-center"
        }
      >
        {t("pages:home:searchAnotherPlate")}
      </button>

      <PartnersConcessionairesDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
    </div>
  );
}
